export const MEDIA_CDN_URL = "https://d1yy64eivt5sz6.cloudfront.net";

export const mediaUrl = (path: string) =>
  `${MEDIA_CDN_URL}/${path.replace(/^\/+/, "")}`;
